import AssetImage from "@/components/AssetImage";
import FrameButton from "@/components/buttons/FrameButton";
import FrameModalBody from "@/components/modals/modalComponents/FrameModalBody";
import FrameModalFooter from "@/components/modals/modalComponents/FrameModalFooter";
import FrameOneModal from "@/components/modals/modalComponents/FrameOneModal";
import { useAsset } from "@/hooks/useAsset";
import { useGetGuild } from "@/hooks/useGetGuild";
import useThemePreference from "@/hooks/useThemePreference";
import { formatDate } from "@/utils/formatDate";
import { SponsoredGuildCompetitionWinnerResponse, WinningCriteria, DistributedRewardResponse, SponsoredCompetitionNotificationMetadata } from "@devour/client";
import { FC } from "react";
import { IoMdClose } from "react-icons/io";

interface props {
    wonCompetition: SponsoredGuildCompetitionWinnerResponse,
    isOpen: boolean,
    onClose: () => void,
    onDismiss: () => void,
}

export const GuildPrizeWonDialogFromDistributedReward = ({
    isOpen,
    onClose,
    onDismiss,
    reward,
}: {
    isOpen: boolean,
    onClose: () => void,
    onDismiss: () => void,
    reward: DistributedRewardResponse
}) => {
    const notificationMetadata = reward.notificationMetadata as SponsoredCompetitionNotificationMetadata;
    const { isOnDarkMode } = useThemePreference();
    const { data: guild} = useGetGuild(notificationMetadata.guildId);
    const {data: guildImage} = useAsset(guild?.hero);
    const prizeName = reward?.description;
    const guildName = guild?.name ?? "";
    function getMonthName() {
        const date = new Date(reward.createdAt);
        const monthName = date.toLocaleString("en-US", { month: "long" });
        return monthName;
    }

    const getTitle = () => {
        switch (notificationMetadata.winningCriteria) {
            case WinningCriteria.TOPOVERALLXPGAINER:
                return `You are Guilds Overall XP Winner for ${getMonthName()}!`;
            case WinningCriteria.TOPGUILDXPGAINER:
                return `You are ${guildName} XP Winner for ${getMonthName()}!`;
            case WinningCriteria.WINNINGGUILD:
                return `${guildName} is the Guild Winner for ${getMonthName()}!`;
            default:
                return "";
        }
    };
    const getDescription = () => {
        switch (notificationMetadata.winningCriteria) {
            case WinningCriteria.TOPOVERALLXPGAINER:
                return `You were the Top XP Leader! 🏆 ${prizeName} has been awarded to your account.`;
            case WinningCriteria.TOPGUILDXPGAINER:
                return `You were the top XP leader this month for your winning ${guildName} guild.! 🏆 ${prizeName} has been awarded to your account.`;
            case WinningCriteria.WINNINGGUILD:
                return `You guild was the top XP leader this month! 🏆 ${prizeName} has been awarded to your account.`;
            default:
                return "";
        }
    };
    return (
        <FrameOneModal size="xs1" isOpen={isOpen} toggle={onClose} contentClassName="guild-prize-won-dialog">
            <div
                className="guild-prize-won-dialog_background"
                style={{
                    backgroundImage: `url(${guildImage?.cdnUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "6.2rem",
                }}></div>
            <div
                className="guild-prize-won-dialog_shader"
                style={{
                    background: `linear-gradient(180deg, rgba(45, 45, 47, 0.10) 0%, ${
                        isOnDarkMode ? "#2D2D2F" : "white"
                    } 6.2rem)`,
                }}
            ></div>
            <IoMdClose className="guild-prize-won-dialog_close" onClick={onClose}/>
            <FrameModalBody className="guild-prize-won-dialog_body">
                <div className="guild-prize-won-dialog_body_heading">
                    <h6>Congratulations</h6>
                    <h5>{getTitle()}</h5>
                </div>
                <div className="guild-prize-won-dialog_body_content">
                    <div className="guild-prize-won-dialog_body_content_prize-placeholder"></div>
                    <h5>{prizeName}</h5>
                    <span>Awarded on {formatDate(reward.createdAt as any)}</span>
                </div>
                <h6 className="guild-prize-won-dialog_body_description">{getDescription()}</h6>
                <FrameButton
                    color="purple"
                    size="normal"
                    onClick={onDismiss}
                >
                    Confirm
                </FrameButton>
            </FrameModalBody>
        </FrameOneModal>
    );
};